import React, { useState } from 'react';
import styles from './index.module.scss';

const PublicationSliderV1 = ({
  contentData,
  contentText,
  contentName,
  imgName,
  imgsNames,
  videoName,
  path_to_folder,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Обработка imgsNames - преобразуем в массив и обрабатываем пути
  const processedImgsNames = React.useMemo(() => {
    if (!imgsNames || imgsNames === '' || imgsNames === '[]') return [];

    let imagesArray = [];

    // Если это строка, пытаемся распарсить как JSON
    if (typeof imgsNames === 'string') {
      try {
        imagesArray = JSON.parse(imgsNames);
      } catch (e) {
        // Если не JSON, разделяем по запятым
        imagesArray = imgsNames
          .split(',')
          .map((img) => img.trim())
          .filter((img) => img && img !== 'none');
      }
    } else if (Array.isArray(imgsNames)) {
      imagesArray = imgsNames.filter((img) => img && img !== 'none');
    }

    // Обрабатываем каждый путь изображения
    return imagesArray.map((imgName) => {
      if (imgName && imgName.includes('\\')) {
        return imgName.substring(imgName.lastIndexOf('\\') + 1);
      }
      return imgName;
    });
  }, [imgsNames]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % processedImgsNames.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + processedImgsNames.length) % processedImgsNames.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className={styles.sliderComponent}>
      {processedImgsNames && processedImgsNames.length > 0 && (
        <div className={styles.sliderContainer}>
          <div className={styles.slider}>
            {processedImgsNames.map((processedImgName, index) => (
              <div
                key={index}
                className={`${styles.slide} ${index === currentSlide ? styles.active : ''}`}>
                <img
                  src={path_to_folder + processedImgName}
                  alt={`Изображение ${index + 1}`}
                  className={styles.sliderImage}
                />
              </div>
            ))}
            {processedImgsNames.length > 1 && (
              <>
            <button
              className={`${styles.navButton} ${styles.prevButton}`}
              onClick={prevSlide}
              aria-label='Previous slide'>
              &#8249;
            </button>
            <button
              className={`${styles.navButton} ${styles.nextButton}`}
              onClick={nextSlide}
              aria-label='Next slide'>
              &#8250;
            </button>
              </>
            )}
          </div>
          {processedImgsNames.length > 1 && (
          <div className={styles.thumbnailsContainer}>
            {processedImgsNames.map((processedImgName, index) => (
              <div
                key={index}
                className={`${styles.thumbnail} ${index === currentSlide ? styles.active : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}>
                <img
                  src={path_to_folder + processedImgName}
                  alt={`Thumbnail ${index + 1}`}
                  className={styles.thumbnailImage}
                />
              </div>
            ))}
          </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PublicationSliderV1;
